import { graphql } from 'relay-runtime';

export const UNIFIED_PROFILE_QUERY = graphql`
  query UnifiedProfileQuery(
    $aaid: String
    $username: String
    $internalId: String
  ) {
    unified {
      unifiedProfile(
        aaid: $aaid
        unifiedProfileUsername: $username
        internalId: $internalId
      ) {
        ... on UnifiedProfile {
          ...UnifiedProfileFragment
        }
        ... on UnifiedQueryError {
          identifier
          message
          extensions {
            errorType
            statusCode
          }
        }
      }
      atlassianProducts {
        ... on UnifiedAtlassianProductConnection {
          ...AtlassianProductsFragment
        }
      }
    }
  }
`;
